import { ApplicationEnum } from "~/@types/enums";

const OPT_IN_APP_KEYS: ReadonlySet<string> = new Set<string>([ApplicationEnum.BENCHMARK, ApplicationEnum.COUNT]);

export const requiresOptIn = (key: string): boolean => OPT_IN_APP_KEYS.has(key);

const isAppSurfaced = (key: string, enabledByKey: Partial<Record<string, boolean>>): boolean =>
	!requiresOptIn(key) || enabledByKey[key] === true;

export default isAppSurfaced;
